import { t } from 'i18next';
import { Cell } from 'react-table';

import { CellText, LinkText } from 'coreOld/elements';
import { formatDate, getPath, uniqueArray } from 'coreOld/utils';
import { supportRequestJobListPath } from 'support/routes/routePaths';
import { IRequest } from 'support/types';

export const columns = [
  {
    accessor: 'id',
    Header: () => <CellText mainText={t('labelRequestId')} />,
    Cell: ({ row }: Cell<IRequest>) => {
      const requestId = row.original.id;

      return (
        <CellText
          mainText={
            <LinkText href={getPath(supportRequestJobListPath(requestId))}>{requestId}</LinkText>
          }
        />
      );
    },
    flex: 60,
  },
  {
    accessor: 'projectName',
    Header: () => <CellText mainText={t('labelProject')} />,
  },
  {
    accessor: 'bomsMap',
    Header: () => <CellText mainText={t('labelDisciplines')} />,
    Cell: ({ row }: Cell<IRequest>) => {
      const disciplineNames = uniqueArray(
        Object.keys(row.original.bomsMap)
          .map((key) => row.original.bomsMap[key].disciplineName)
          .filter((value) => value != null)
      );

      return <CellText mainText={disciplineNames.join('\n')} />;
    },
  },
  {
    accessor: 'customerName',
    Header: () => (
      <CellText
        mainText={t('labelSupportRequestCustomerCompanyName')}
        subTexts={[t('labelSupportRequestCustomerContactName')]}
      />
    ),
    Cell: ({ row }: Cell<IRequest>) => {
      return (
        <CellText
          mainText={row.original.customerCompanyName}
          subTexts={[row.original.customerName]}
        />
      );
    },
    flex: 200,
  },
  {
    accessor: 'externalLocationRegion',
    Header: () => <CellText mainText={t('labelTheatre')} subTexts={[t('labelCountry')]} />,
    Cell: ({ row }: Cell<IRequest>) => {
      return (
        <CellText
          mainText={row.original.externalLocationRegion || '-'}
          subTexts={[row.original.externalLocationCountry || '-']}
        />
      );
    },
    flex: 50,
  },
  {
    accessor: 'statusName',
    Header: () => (
      <CellText
        mainText={t('labelSupportRequestStatus')}
        subTexts={[t('labelSupportRequestLevel')]}
      />
    ),
    Cell: ({ row }: Cell<IRequest>) => {
      return <CellText mainText={row.original.statusName} subTexts={[row.original.levelName]} />;
    },
    flex: 100,
  },
  {
    accessor: 'requiredByDate',
    Header: () => (
      <CellText mainText={t('labelRequestedDate')} subTexts={[t('labelLastUpdated')]} />
    ),
    Cell: ({ row }: Cell<IRequest>) => {
      return (
        <CellText
          mainText={formatDate(row.original.requiredByDate)}
          subTexts={[formatDate(row.original.updatedAt)]}
        />
      );
    },
    flex: 100,
  },
  {
    accessor: 'userName',
    Header: () => <CellText mainText={t('labelCreatedByUser')} />,
    flex: 200,
  },
];
